import { addSuggestionPillInternal } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(addSuggestionPillInternal, function (actionMessage) {
    var searchStore = getStore();
    var suggestionPill = actionMessage.suggestionPill;
    var pillId = suggestionPill.ReferenceId;
    /**
     * Add the suggestion pill to the collection, as well as adding its ID to
     * the array of IDs to maintain order.
     */
    searchStore.suggestionPills.set(pillId, suggestionPill);
    searchStore.suggestionPillIds.push(pillId);
});
//# sourceMappingURL=addSuggestionPillInternalMutator.js.map